import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Product } from "../pages/ProductContent/Product";
import { generateQuotationPDF } from "../pages/Qutation/PdfGenerator";
import mangrishLogo from "../assets/logo.jpeg";
import princePipesLogo from "../assets/products-banner.jpeg";
import princePipesLogo1 from "../assets/product-banner.jpeg";
import { Navigate, useNavigate } from "react-router-dom";
import api from "../services/api";
import QuotationPreview from "./Quotationmaking/QuotationPreview";

interface QuotationProduct {
  productId: string;
  name: string;
  qty: number;
  unit: string;
  mrp: number;
  discount1: number;
  discount2: number;
  discount: number;
  rate: number;
  amount: number;
  hsncode: string;
  gstpercentage: number;
}

interface BankDetails {
  name: string;
  accountNo: string;
  branch: string;
  ifsc: string;
  bankName: string;
}

// Dynamic bank options based on GST number
const getBankOptions = (gstNumber: string) => {
  if (gstNumber === "29ACAFM2729C1ZG") {
    // Partnership GST - Central Bank only
    return [
      {
        id: 1,
        label: "Central Bank (Partnership) - (5634831064)",
        value: {
          name: "MANGRISH",
          accountNo: "5634831064",
          branch: "Kodigehalli, Bangalore 560097",
          ifsc: "CBIN0283697",
          bankName: "CENTRAL BANK OF INDIA",
        },
      },
      {
        id: 2,
        label: "Manual Entry",
        value: "manual",
      },
    ];
  } else if (gstNumber === "29AAEPS9027R1ZP") {
    // Proprietor GST - Two banks + manual
    return [
      {
        id: 1,
        label: "Central Bank (Proprietor) - (3072665777)",
        value: {
          name: "MANGRISH",
          accountNo: "3072665777 (account type OD)",
          branch: "Kodigehalli, Bangalore 560097",
          ifsc: "CBIN0283697",
          bankName: "CENTRAL BANK OF INDIA",
        },
      },
      {
        id: 2,
        label: "Kotak Mahindra Bank (Proprietor) - (8645216855)",
        value: {
          name: "MANGRISH",
          accountNo: "8645216855",
          branch: "Sahakarnagar, Bangalore 560097",
          ifsc: "KKBK00008045",
          bankName: "KOTAK MAHINDRA BANK",
        },
      },
      {
        id: 3,
        label: "Manual Entry",
        value: "manual",
      },
    ];
  } else {
    // Default - Manual entry only
    return [
      {
        id: 1,
        label: "Manual Entry",
        value: "manual",
      },
    ];
  }
};

const GST_NUMBERS = [
  {
    value: "29ACAFM2729C1ZG",
    label: "29ACAFM2729C1ZG - MAngrish (Partnership)",
  },
  {
    value: "29AAEPS9027R1ZP",
    label: "29AAEPS9027R1ZP - MANGRISH (Proprietor)",
  },
];

const QuotationForm: React.FC = () => {
  const navigate = useNavigate();
  const [allProducts, setAllProducts] = useState<Product[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<QuotationProduct[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");
  const [quotationId, setQuotationId] = useState("");
  const [validationErrors, setValidationErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedGstNumber, setSelectedGstNumber] = useState("");
  const [transportation, setTransportation] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [searchMethod, setSearchMethod] = useState<'direct' | 'filter'>('direct');
  const [selectedBrand, setSelectedBrand] = useState<string>('');
  const [brands, setBrands] = useState<string[]>([]);
  const [showPreview, setShowPreview] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingType, setEditingType] = useState<'billTo' | 'shipTo'>('billTo');

  const [billTo, setBillTo] = useState({
    name: "M/s Hiran Enterprises",
    address: "62, kaka thoppu street\nMadurai - 625001",
    email: "hiranenterprises2010@gmail.com",
    phone: "98945 42261",
  });

  const [shipTo, setShipTo] = useState({
    name: "",
    address: "",
    email: "",
    phone: "",
  });

  const [note, setNote] = useState(
    "1. pipes available 100mtrs Coils & Per coil One coupler Free"
  );
  const [terms, setTerms] = useState([
    "Transportation Extra on your account",
    "Payment 100% Advance",
    "Price variation clause applicable",
    "Unloading on your account",
    "Quotation valid 7 days",
    "Goods once sold will not take back",
    "Disputes subject to Bangalore jurisdiction",
  ]);

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [totalgstPercentage, setTotalGstPercentage] = useState(18);

  const [selectedBank, setSelectedBank] = useState<BankDetails>({
    name: "MANGRISH",
    accountNo: "5634831064",
    branch: "Kodigehalli, Bangalore 560097",
    ifsc: "CBIN0283697",
    bankName: "CENTRAL BANK OF INDIA",
  });
  const [isManualBank, setIsManualBank] = useState(false);
  const [bankDetails, setBankDetails] = useState<BankDetails>({
    name: "MANGRISH",
    accountNo: "5634831064",
    branch: "Kodigehalli, Bangalore 560097",
    ifsc: "CBIN0283697",
    bankName: "CENTRAL BANK OF INDIA",
  });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          "https://api.mangrishprince.com/api/v1/products",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAllProducts(res.data);
        setFilteredProducts(res.data);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  // Load brands on component mount
  useEffect(() => {
    const loadBrands = async () => {
      try {
        const response = await api.get('/inventory/brands');
        setBrands(response.data.brands);
      } catch (err) {
        console.error('Failed to load brands:', err);
      }
    };
    loadBrands();
  }, []);

  // Reset bank selection when GST number changes
  useEffect(() => {
    if (selectedGstNumber) {
      const bankOptions = getBankOptions(selectedGstNumber);
      if (bankOptions.length > 0) {
        const firstBank = bankOptions[0];
        if (firstBank.value !== "manual") {
          setSelectedBank(firstBank.value as BankDetails);
          setIsManualBank(false);
        } else {
          setIsManualBank(true);
        }
      }
    }
  }, [selectedGstNumber]);

  // Handle input changes for Bill To fields
  const handleBillToChange = useCallback((field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    setBillTo((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  // Handle input changes for Ship To fields
  const handleShipToChange = useCallback((field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    setShipTo((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  // Handle input changes for other form fields
  const handleInputChange = useCallback((
    setter: React.Dispatch<React.SetStateAction<any>>,
    field?: string
  ) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (field) {
      setter((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    } else {
      setter(value);
    }
  }, []);

  const handleAddProduct = (product: Product) => {
    if (!product._id) {
      console.error("Product ID is missing");
      return;
    }

    const newProduct: QuotationProduct = {
      productId: product._id.toString(),
      name: product.name,
      qty: 1,
      unit: product.unit,
      mrp: product.mrp,
      discount1: 0,
      discount2: 0,
      discount: 0,
      rate: product.mrp,
      amount: product.mrp,
      hsncode: product.hsncode || "",
      gstpercentage: product.gstpercentage || 18,
    };
    setSelectedProducts(prev => [...prev, newProduct]);
    setValidationErrors(prev => ({ ...prev, products: "" }));
  };

  const updateProduct = useCallback(
    (index: number, field: keyof QuotationProduct, value: any) => {
      setSelectedProducts(prev => {
        const updated = [...prev];
        
        if (field === "mrp" || field === "rate") {
          value = Math.max(0, parseFloat(value) || 0);
        }
        if (field === "qty") {
          value = Math.max(1, parseInt(value) || 1);
        }
        if (field === "discount") {
          value = Math.max(0, Math.min(100, parseFloat(value) || 0));
        }

        updated[index] = {
          ...updated[index],
          [field]: value,
        };

        // Calculate rate and amount when MRP, discount, or qty changes
        if (field === "mrp" || field === "discount") {
          const mrp = field === "mrp" ? value : updated[index].mrp;
          const discount = field === "discount" ? value : updated[index].discount;
          updated[index].rate = mrp * (1 - discount / 100);
          updated[index].amount = updated[index].rate * updated[index].qty;
        } else if (field === "rate" || field === "qty") {
          updated[index].amount = updated[index].rate * updated[index].qty;
        }

        return updated;
      });
    },
    []
  );

  const validateForm = () => {
    const errors: Record<string, string> = {};

    if (!billTo.name.trim()) errors.billToName = "Name is required";
    if (!billTo.address.trim()) errors.billToAddress = "Address is required";
    if (!billTo.phone.trim()) errors.billToPhone = "Phone is required";
    if (!selectedGstNumber.trim()) errors.gstNumber = "GST Number is required";

    if (!shipTo.name.trim()) errors.shipToName = "Name is required";
    if (!shipTo.address.trim()) errors.shipToAddress = "Address is required";
    if (!shipTo.phone.trim()) errors.shipToPhone = "Phone is required";

    if (selectedProducts.length === 0) {
      errors.products = "At least one product must be added";
    } else {
      selectedProducts.forEach((product, index) => {
        if (product.mrp <= 0) {
          errors[`product-${index}-mrp`] = `MRP for ${product.name} must be greater than zero`;
        }
        if (product.amount <= 0) {
          errors[`product-${index}-amount`] = `Amount for ${product.name} must be greater than zero`;
        }
      });
    }

    if (!date.trim()) errors.date = "Date is required";

    const currentBankDetails = isManualBank ? bankDetails : selectedBank;
    if (!currentBankDetails.name.trim()) errors.bankName = "Account holder name is required";
    if (!currentBankDetails.accountNo.trim()) errors.bankAccount = "Account number is required";
    if (!currentBankDetails.branch.trim()) errors.bankBranch = "Branch is required";
    if (!currentBankDetails.ifsc.trim()) errors.bankIfsc = "IFSC code is required";

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSearch = (query: string) => {
    setSearch(query);
    
    if (searchMethod === 'filter' && selectedBrand) {
      // Filter method: first filter by brand, then by query
      setFilteredProducts(
        allProducts.filter(
          (p) =>
            p.category === selectedBrand &&
            (p.name.toLowerCase().includes(query.toLowerCase()) ||
             (p.no && p.no.toLowerCase().includes(query.toLowerCase())))
        )
      );
    } else {
      // Direct method: search directly by product name or number
      setFilteredProducts(
        allProducts.filter(
          (p) =>
            p.name.toLowerCase().includes(query.toLowerCase()) ||
            (p.no && p.no.toLowerCase().includes(query.toLowerCase()))
        )
      );
    }
  };

  const handleRemoveProduct = (index: number) => {
    setSelectedProducts(prev => {
      const updatedProducts = [...prev];
      updatedProducts.splice(index, 1);
      return updatedProducts;
    });
  };

  const addTerm = () => setTerms(prev => [...prev, ""]);
  const updateTerm = (index: number, value: string) => {
    setTerms(prev => {
      const updatedTerms = [...prev];
      updatedTerms[index] = value;
      return updatedTerms;
    });
  };
  const removeTerm = (index: number) => {
    setTerms(prev => {
      const updatedTerms = [...prev];
      updatedTerms.splice(index, 1);
      return updatedTerms;
    });
  };

  const calculateProductTotal = () =>
    selectedProducts.reduce((sum, product) => sum + product.amount, 0);

  const calculateDiscountAmount = () => {
    const productTotal = calculateProductTotal();
    return (productTotal * discount) / 100;
  };

  const calculateSubtotal = () => {
    const productTotal = calculateProductTotal();
    const discountAmount = calculateDiscountAmount();
    return productTotal - discountAmount + transportation;
  };
  
  const calculateGst = () => calculateSubtotal() * (totalgstPercentage / 100);
  const calculateTotal = () => calculateSubtotal() + calculateGst();

  const handleBankChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value === "manual") {
      setIsManualBank(true);
      setBankDetails({
        name: "",
        accountNo: "",
        branch: "",
        ifsc: "",
        bankName: ""
      });
    } else {
      setIsManualBank(false);
      setSelectedBank(JSON.parse(e.target.value));
    }
  };

  // const handleInputChange = (
  //   setter: React.Dispatch<React.SetStateAction<any>>,
  //   field?: string
  // ) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   const value = e.target.value;
  //   if (field) {
  //     setter((prev: any) => ({ ...prev, [field]: value }));
  //   } else {
  //     setter(value);
  //   }
  // };

  const handleSubmit = async () => {
    if (!validateForm()) {
      const firstError = Object.keys(validationErrors)[0];
      if (firstError) {
        const element = document.querySelector(`[data-field="${firstError}"]`);
        element?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }
    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("token");
      const bankDetailsToUse = isManualBank ? bankDetails : selectedBank;
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1'}/quotations`,
        {
          date: new Date(date),
          gstNumber: selectedGstNumber,
          billTo,
          shipTo,
          products: selectedProducts,
          transportation,
          discount,
          totalgstPercentage,
          totalAmount: calculateTotal().toFixed(2),
          note,
          terms: terms.filter((t) => t.trim() !== ""),
          bank: bankDetailsToUse,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setQuotationId(response.data._id);
      setValidationErrors({
        success: "Quotation created successfully!",
      });
       navigate("/quotation/history");
    } catch (error) {
      setValidationErrors({
        submitError: "Error creating quotation. Please try again.",
      });
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGeneratePDF = async () => {
    if (!validateForm()) return;

    try {
      setIsSubmitting(true);
      const bankDetailsToUse = isManualBank ? bankDetails : selectedBank;

      generateQuotationPDF({
        quotationNo: "123",
        date,
        gstNumber: selectedGstNumber,
        billTo,
        shipTo,
        selectedProducts,
        note,
        terms,
        bankDetails: bankDetailsToUse,
        transportation,
        totalgstPercentage,
        totalAmount: calculateTotal(),
        calculateSubtotal,
        calculateGst,
        calculateTotal,
        mangrishLogo,
        princePipesLogo,
        princePipesLogo1
      });
    } catch (error) {
      console.error("Error creating quotation:", error);
      setValidationErrors({
        submitError: "Error creating quotation. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePreview = () => {
    if (!validateForm()) return;
    setShowPreview(true);
  };

  const handleBackFromPreview = () => {
    setShowPreview(false);
  };

  const handleEditDetails = (type: 'billTo' | 'shipTo') => {
    setEditingType(type);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleSaveDetails = () => {
    setShowEditModal(false);
  };

  // const FormField = React.memo(
  //   ({
  //     label,
  //     value,
  //     onChange,
  //     error,
  //     type = "text",
  //     placeholder = "",
  //     required = false,
  //     textarea = false,
  //     rows = 3,
  //     className = "",
  //     disabled = false,
  //     fieldName = "",
  //   }: {
  //     label: string;
  //     value: string;
  //     onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  //     error?: string;
  //     type?: string;
  //     placeholder?: string;
  //     required?: boolean;
  //     textarea?: boolean;
  //     rows?: number;
  //     className?: string;
  //     disabled?: boolean;
  //     fieldName?: string;
  //   }) => {
  //     return (
  //       <div className={`mb-4 ${className}`} data-field={fieldName}>
  //         <label className={`block text-sm font-medium ${error ? "text-red-600" : "text-gray-700"} mb-1`}>
  //           {label} {required && <span className="text-red-500">*</span>}
  //         </label>
  //         {textarea ? (
  //           <textarea
  //             className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
  //               error ? "border-red-500" : "border-gray-300"
  //             } ${disabled ? "bg-gray-100" : ""}`}
  //             rows={rows}
  //             value={value}
  //             onChange={onChange}
  //             placeholder={placeholder}
  //             disabled={disabled}
  //           />
  //         ) : (
  //           <input
  //             type={type}
  //             className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
  //               error ? "border-red-500" : "border-gray-300"
  //             } ${disabled ? "bg-gray-100" : ""}`}
  //             value={value}
  //             onChange={onChange}
  //             placeholder={placeholder}
  //             disabled={disabled}
  //           />
  //         )}
  //         {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
  //       </div>
  //     );
  //   }
  // );
const FormField = React.memo(
  ({
    label,
    value,
    onChange,
    error,
    type = "text",
    placeholder = "",
    required = false,
    textarea = false,
    rows = 3,
    className = "",
    disabled = false,
    fieldName = "",
  }: {
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    error?: string;
    type?: string;
    placeholder?: string;
    required?: boolean;
    textarea?: boolean;
    rows?: number;
    className?: string;
    disabled?: boolean;
    fieldName?: string;
  }) => {
    return (
      <div className={`mb-4 ${className}`} data-field={fieldName}>
        <label className={`block text-sm font-medium ${error ? "text-red-600" : "text-gray-700"} mb-1`}>
          {label} {required && <span className="text-red-500">*</span>}
        </label>
        {textarea ? (
          <textarea
            className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              error ? "border-red-500" : "border-gray-300"
            } ${disabled ? "bg-gray-100" : ""}`}
            rows={rows}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
          />
        ) : (
          <input
            type={type}
            className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              error ? "border-red-500" : "border-gray-300"
            } ${disabled ? "bg-gray-100" : ""}`}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
          />
        )}
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
      </div>
    );
  }
);

  // If preview is shown, display the preview component
  if (showPreview) {
    const bankDetailsToUse = isManualBank ? bankDetails : selectedBank;
    const previewData = {
      quotationNo: "PREVIEW",
      date,
      gstNumber: selectedGstNumber,
      billTo,
      shipTo,
      products: selectedProducts,
      note,
      terms: terms.filter((t) => t.trim() !== ""),
      bank: bankDetailsToUse,
      productTotal: calculateProductTotal(),
      discount: discount,
      discountAmount: calculateDiscountAmount(),
      transportation: transportation,
      subtotal: calculateSubtotal(),
      gst: totalgstPercentage,
      gstAmount: calculateGst(),
      total: calculateTotal()
    };

    return (
      <QuotationPreview 
        data={previewData} 
        onBack={handleBackFromPreview} 
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-6">
          <h1 className="text-2xl font-bold">Create New Quotation</h1>
          <p className="text-blue-100 opacity-90">
            Fill in the details below to generate a quotation
          </p>
        </div>

        <div className="p-6">
          {validationErrors.success && (
            <div className="mb-6 p-4 bg-green-50 border border-green-200 text-green-700 rounded-md">
              {validationErrors.success}
            </div>
          )}
          {validationErrors.submitError && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 text-red-700 rounded-md">
              {validationErrors.submitError}
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            {/* Bill To Card */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors" onClick={() => handleEditDetails('billTo')}>
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-gray-700 text-lg border-b pb-2 flex items-center">
                  <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  Bill To
                </h3>
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </div>
              <div className="space-y-2">
                <div>
                  <span className="text-sm font-medium text-gray-600">Name:</span>
                  <p className="text-gray-900">{billTo.name || 'Click to add'}</p>
                </div>
                <div>
                  <span className="text-sm font-medium text-gray-600">Address:</span>
                  <p className="text-gray-900 whitespace-pre-line">{billTo.address || 'Click to add'}</p>
                </div>
                <div>
                  <span className="text-sm font-medium text-gray-600">Phone:</span>
                  <p className="text-gray-900">{billTo.phone || 'Click to add'}</p>
                </div>
                <div>
                  <span className="text-sm font-medium text-gray-600">Email:</span>
                  <p className="text-gray-900">{billTo.email || 'Click to add'}</p>
                </div>
              </div>
            </div>

            {/* Quotation Details */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <h3 className="font-bold text-gray-700 mb-4 text-lg border-b pb-2 flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Quotation Details
              </h3>
              <div className="mb-4" data-field="gstNumber">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  GST Number <span className="text-red-500">*</span>
                </label>
                <select
                  value={selectedGstNumber}
                  onChange={(e) => setSelectedGstNumber(e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                    validationErrors.gstNumber ? "border-red-500" : "border-gray-300"
                  }`}
                  required
                >
                  <option value="">Select GST Number</option>
                  {GST_NUMBERS.map((gst) => (
                    <option key={gst.value} value={gst.value}>
                      {gst.label}
                    </option>
                  ))}
                </select>
                {validationErrors.gstNumber && (
                  <p className="mt-1 text-sm text-red-600">
                    {validationErrors.gstNumber}
                  </p>
                )}
              </div>
              <FormField
                label="Date"
                value={date}
                onChange={handleInputChange(setDate)}
                error={validationErrors.date}
                type="date"
                required
                fieldName="date"
              />
            </div>
          </div>

          {/* Ship To Card */}
          <div className="bg-gray-50 p-4 rounded-lg mb-8 border border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors" onClick={() => handleEditDetails('shipTo')}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-bold text-gray-700 text-lg border-b pb-2 flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Ship To
              </h3>
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <span className="text-sm font-medium text-gray-600">Name:</span>
                <p className="text-gray-900">{shipTo.name || 'Click to add'}</p>
              </div>
              <div>
                <span className="text-sm font-medium text-gray-600">Phone:</span>
                <p className="text-gray-900">{shipTo.phone || 'Click to add'}</p>
              </div>
            </div>
            <div className="mt-4">
              <span className="text-sm font-medium text-gray-600">Address:</span>
              <p className="text-gray-900 whitespace-pre-line">{shipTo.address || 'Click to add'}</p>
            </div>
            <div className="mt-2">
              <span className="text-sm font-medium text-gray-600">Email:</span>
              <p className="text-gray-900">{shipTo.email || 'Click to add'}</p>
            </div>
          </div>

          <div className="mb-8">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-bold text-gray-700 text-lg flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
                Products
              </h3>
              <button
                onClick={() => setShowModal(true)}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center shadow-sm"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                Add Product
              </button>
            </div>

            {validationErrors.products && (
              <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-md" data-field="products">
                {validationErrors.products}
              </div>
            )}

            {selectedProducts.length > 0 ? (
              <div className="overflow-x-auto border border-gray-200 rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">HSN Code</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Qty</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Unit</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">MRP</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Disc%</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Rate</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {selectedProducts.map((product, idx) => (
                      <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                        <td className="px-4 py-4 whitespace-nowrap">
                          <div className="font-medium text-gray-900">{product.name}</div>
                          {/* <div className="text-sm text-gray-500"></div> */}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="text-sm text-gray-500">{product.hsncode}</div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <input
                            type="number"
                            min="1"
                            value={product.qty}
                            onChange={(e) => updateProduct(idx, "qty", parseInt(e.target.value) || 1)}
                            className="w-16 border border-gray-300 rounded-md px-2 py-1 text-center focus:ring-2 focus:ring-blue-500"
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                          {product.unit}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <input
                            type="number"
                            step="0.01"
                            min="0"
                            value={product.mrp}
                            onChange={(e) => updateProduct(idx, "mrp", parseFloat(e.target.value) || 0)}
                            className={`w-20 border rounded-md px-2 py-1 text-center focus:ring-2 focus:ring-blue-500 ${
                              validationErrors[`product-${idx}-mrp`] ? "border-red-500" : "border-gray-300"
                            }`}
                          />
                          {validationErrors[`product-${idx}-mrp`] && (
                            <p className="text-xs text-red-500 mt-1">
                              {validationErrors[`product-${idx}-mrp`]}
                            </p>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <input
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            value={product.discount}
                            onChange={(e) => updateProduct(idx, "discount", parseFloat(e.target.value) || 0)}
                            className="w-16 border border-gray-300 rounded-md px-2 py-1 text-center focus:ring-2 focus:ring-blue-500"
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className="flex items-center justify-center">
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              value={product.rate}
                              onChange={(e) => updateProduct(idx, "rate", parseFloat(e.target.value) || 0)}
                              className="w-20 border border-gray-300 rounded-md px-2 py-1 text-center focus:ring-2 focus:ring-blue-500"
                            />
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <div className={`flex items-center justify-center ${
                            validationErrors[`product-${idx}-amount`] ? "text-red-500" : ""
                          }`}>
                            ₹{product.amount.toFixed(2)}
                          </div>
                          {validationErrors[`product-${idx}-amount`] && (
                            <p className="text-xs text-red-500 mt-1">
                              {validationErrors[`product-${idx}-amount`]}
                            </p>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                          <button
                            onClick={() => handleRemoveProduct(idx)}
                            className="text-red-600 hover:text-red-900"
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="bg-gray-100 rounded-lg p-8 text-center text-gray-500 border border-gray-200">
                No products added yet. Click "Add Product" to get started.
              </div>
            )}

            <div className="flex justify-end mt-6">
              <div className="w-full md:w-96 border border-gray-200 rounded-lg overflow-hidden">
                <table className="w-full">
                  <tbody>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 py-3 font-medium text-gray-700">Product Total</td>
                      <td className="px-4 py-3 text-right font-medium">
                        ₹{calculateProductTotal().toFixed(2)}
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 py-3 font-medium text-gray-700 flex items-center">
                        Discount %
                        <input
                          type="number"
                          min="0"
                          max="100"
                          step="0.01"
                          value={discount}
                          onChange={(e) => setDiscount(parseFloat(e.target.value) || 0)}
                          className="w-16 ml-2 border border-gray-300 rounded-md px-2 py-1 focus:ring-2 focus:ring-blue-500"
                          placeholder="0.00"
                        />
                      </td>
                      <td className="px-4 py-3 text-right font-medium text-green-600">
                        -₹{calculateDiscountAmount().toFixed(2)}
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 py-3 font-medium text-gray-700">Transportation</td>
                      <td className="px-4 py-3 text-right">
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={transportation}
                          onChange={(e) => setTransportation(parseFloat(e.target.value) || 0)}
                          className="w-24 border border-gray-300 rounded-md px-2 py-1 text-right focus:ring-2 focus:ring-blue-500"
                        />
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 py-3 font-medium text-gray-700">Sub total</td>
                      <td className="px-4 py-3 text-right font-medium">
                        ₹{calculateSubtotal().toFixed(2)}
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200">
                      <td className="px-4 py-3 font-medium text-gray-700 flex items-center">
                        GST %
                        <input
                          type="number"
                          min="0"
                          max="100"
                          value={totalgstPercentage}
                          onChange={(e) => setTotalGstPercentage(parseFloat(e.target.value) || 0)}
                          className="w-16 ml-2 border border-gray-300 rounded-md px-2 py-1 focus:ring-2 focus:ring-blue-500"
                        />
                      </td>
                      <td className="px-4 py-3 text-right font-medium">
                        ₹{calculateGst().toFixed(2)}
                      </td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="px-4 py-3 font-bold text-gray-800">Total</td>
                      <td className="px-4 py-3 text-right font-bold text-gray-800">
                        ₹{calculateTotal().toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="mb-8">
            <h3 className="font-bold text-gray-700 mb-2 text-lg flex items-center">
              <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
              </svg>
              Note
            </h3>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={3}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Additional notes..."
            />
          </div>

          <div className="mb-8">
            <div className="flex justify-between items-center mb-2">
              <h3 className="font-bold text-gray-700 text-lg flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                Terms & Conditions
              </h3>
              <button
                onClick={addTerm}
                className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors flex items-center text-sm"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
                </svg>
                Add Term
              </button>
            </div>
            <div className="space-y-2">
              {terms.map((term, index) => (
                <div key={index} className="flex items-center">
                  <span className="mr-2 text-gray-600">{index + 1}.</span>
                  <input
                    type="text"
                    className="flex-grow px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={term}
                    onChange={(e) => updateTerm(index, e.target.value)}
                  />
                  <button
                    onClick={() => removeTerm(index)}
                    className="ml-2 p-1 text-red-500 hover:text-red-700 rounded-full hover:bg-red-50"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-8">
            <h3 className="font-bold text-gray-700 mb-4 text-lg border-b pb-2 flex items-center">
              <svg className="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
              </svg>
              Bank Details
            </h3>
            <div className="bg-gray-50 p-4 rounded-md border border-gray-200">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Select Bank <span className="text-red-500">*</span>
                </label>
                <select
                  value={isManualBank ? "manual" : JSON.stringify(selectedBank)}
                  onChange={handleBankChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {getBankOptions(selectedGstNumber).map((bank) => (
                    <option
                      key={bank.id}
                      value={bank.value === "manual" ? "manual" : JSON.stringify(bank.value)}
                    >
                      {bank.label}
                    </option>
                  ))}
                </select>
              </div>

              {isManualBank ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <FormField
                    label="Payment favoring to"
                    value={bankDetails.name}
                    onChange={handleInputChange(setBankDetails, "name")}
                    error={validationErrors.bankName}
                    required
                    fieldName="bankName"
                  />
                  <FormField
                    label="Bank Name"
                    value={bankDetails.bankName}
                    onChange={handleInputChange(setBankDetails, "bankName")}
                    error={validationErrors.bankName}
                    required
                    fieldName="bankName"
                  />
                  <FormField
                    label="Account Number"
                    value={bankDetails.accountNo}
                    onChange={handleInputChange(setBankDetails, "accountNo")}
                    error={validationErrors.bankAccount}
                    required
                    fieldName="bankAccount"
                  />
                  <FormField
                    label="Branch"
                    value={bankDetails.branch}
                    onChange={handleInputChange(setBankDetails, "branch")}
                    error={validationErrors.bankBranch}
                    required
                    fieldName="bankBranch"
                  />
                  <div className="md:col-span-2">
                    <FormField
                      label="IFSC Code"
                      value={bankDetails.ifsc}
                      onChange={handleInputChange(setBankDetails, "ifsc")}
                      error={validationErrors.bankIfsc}
                      required
                      fieldName="bankIfsc"
                    />
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Payment favoring to
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100"
                      value={selectedBank.name}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Bank Name
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100"
                      value={selectedBank.bankName}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Account Number
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100"
                      value={selectedBank.accountNo}
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Branch
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100"
                      value={selectedBank.branch}
                      readOnly
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      IFSC Code
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100"
                      value={selectedBank.ifsc}
                      readOnly
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-end gap-4 mt-8 border-t pt-6">
            <button
              onClick={handlePreview}
              disabled={isSubmitting}
              className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
              </svg>
              Preview
            </button>
            <button
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors flex items-center justify-center shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </>
              ) : (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  Submit Quotation
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col">
            <div className="flex justify-between items-center border-b p-4">
              <h3 className="text-lg font-bold text-gray-800">Select Product</h3>
              <button onClick={() => setShowModal(false)} className="text-gray-500 hover:text-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="p-4 border-b space-y-3">
              <div className="flex gap-2 items-center">
                <label className="text-sm font-medium text-gray-700">Search Method:</label>
                <select 
                  className="border rounded p-1 text-sm" 
                  value={searchMethod} 
                  onChange={(e) => setSearchMethod(e.target.value as 'direct' | 'filter')}
                >
                  <option value="direct">Direct Search</option>
                  <option value="filter">Filter by Brand</option>
                </select>
              </div>
              
              {searchMethod === 'filter' && (
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={selectedBrand}
                  onChange={(e) => setSelectedBrand(e.target.value)}
                >
                  <option value="">Select Brand</option>
                  {brands.map((brand) => (
                    <option key={brand} value={brand}>
                      {brand}
                    </option>
                  ))}
                </select>
              )}
              
              <input
                type="text"
                placeholder={searchMethod === 'filter' ? 'Search within selected brand...' : 'Search product by name or code...'}
                className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <div className="flex-grow overflow-y-auto">
              {filteredProducts.length > 0 ? (
                <ul className="divide-y divide-gray-200">
                  {filteredProducts.map((product) => (
                    <li
                      key={product._id}
                      className="p-4 hover:bg-blue-50 cursor-pointer transition-colors"
                      onClick={() => {
                        handleAddProduct(product);
                        setShowModal(false);
                      }}
                    >
                      <div className="flex justify-between items-start">
                        <div>
                          <div className="font-medium text-gray-800">{product.name}</div>
                          <div className="text-sm text-gray-500 mt-1">MRP: ₹{product.mrp} | Unit: {product.unit}</div>
                          <div className="text-xs text-gray-400 mt-1">
                            HSN: {product.hsncode} | GST: {product.gstpercentage}%
                          </div>
                        </div>
                        <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">Add</span>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="p-8 text-center text-gray-500">No products found matching your search.</div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Edit Details Modal */}
      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col">
            <div className="flex justify-between items-center border-b p-4">
              <h3 className="text-lg font-bold text-gray-800">
                Edit {editingType === 'billTo' ? 'Bill To' : 'Ship To'} Details
              </h3>
              <button onClick={handleCloseEditModal} className="text-gray-500 hover:text-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="flex-grow overflow-y-auto p-6">
              {editingType === 'billTo' ? (
                <div className="space-y-4" key="billTo">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={billTo.name}
                      onChange={(e) => setBillTo(prev => ({ ...prev, name: e.target.value }))}
                      className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                      placeholder="Enter bill to name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Address <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      value={billTo.address}
                      onChange={(e) => setBillTo(prev => ({ ...prev, address: e.target.value }))}
                      rows={3}
                      className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                      placeholder="Enter bill to address"
                    />
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Phone <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        value={billTo.phone}
                        onChange={(e) => setBillTo(prev => ({ ...prev, phone: e.target.value }))}
                        className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                        placeholder="Enter phone number"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                      </label>
                      <input
                        type="email"
                        value={billTo.email}
                        onChange={(e) => setBillTo(prev => ({ ...prev, email: e.target.value }))}
                        className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="space-y-4" key="shipTo">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={shipTo.name}
                      onChange={(e) => setShipTo(prev => ({ ...prev, name: e.target.value }))}
                      className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                      placeholder="Enter ship to name"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Address <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      value={shipTo.address}
                      onChange={(e) => setShipTo(prev => ({ ...prev, address: e.target.value }))}
                      rows={3}
                      className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                      placeholder="Enter ship to address"
                    />
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Phone <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        value={shipTo.phone}
                        onChange={(e) => setShipTo(prev => ({ ...prev, phone: e.target.value }))}
                        className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                        placeholder="Enter phone number"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                      </label>
                      <input
                        type="email"
                        value={shipTo.email}
                        onChange={(e) => setShipTo(prev => ({ ...prev, email: e.target.value }))}
                        className="w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300"
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
              <button
                onClick={handleCloseEditModal}
                className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveDetails}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuotationForm;